import { Typography, useTheme } from '@mui/material'
import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useTranslation } from 'react-i18next'
import {
  BoMItemActivityDto,
  RoutingStep,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { WorkingStepResourceSelector } from '../WorkingSteps/WorkingStepResourceSelector'
import { useNotAllowedWorkingStep } from '../WorkingSteps/useNotAllowedWorkingStep'
import { useRoutingHeaderStyles } from './RoutingHeader.styles'

export const WorkingStepIconWithMachineName = (props: {
  routingStep: RoutingStep
  classes?: {
    root?: string
    icon?: string
    machineName?: string
  }
}) => {
  const { t } = useTranslation()
  return (
    <div className={props.classes?.root}>
      <WorkingStepIconSvg
        workingStepType={props.routingStep.workingStepType}
        className={props.classes?.icon}
      />
      <Typography
        variant="caption"
        color="inherit"
        className={props.classes?.machineName}
      >
        {props.routingStep.resourceName ||
          t('project:no-resources-available')}{' '}
      </Typography>
    </div>
  )
}

export const WorkingStepIconWithResourceSelector = (props: {
  activity: BoMItemActivityDto
  bomItemPointersAndActivities: {
    bomItemPointer: BomItemPointer
    activityId?: string
  }[]
  disableMatchDescription?: boolean
}) => {
  const { classes } = useRoutingHeaderStyles()
  const { t } = useTranslation()
  const theme = useTheme()

  const { workingStepNotAllowed } = useNotAllowedWorkingStep(
    props.bomItemPointersAndActivities[0]?.bomItemPointer,
    props.activity.primaryWorkingStep,
  )

  if (!props.activity) {
    return null
  }

  return (
    <>
      <div className={classes.routingRow}>
        <div className={classes.workingStepWithResource}>
          <WorkingStepIconSvg
            workingStepType={props.activity.primaryWorkingStep}
            className={'working-step-icon'}
          />
          <div
            style={{
              width: '100%',
              padding: '2px',
              color: workingStepNotAllowed
                ? theme.palette.error.contrastText
                : undefined,
              backgroundColor: workingStepNotAllowed
                ? theme.palette.error.main
                : undefined,
            }}
          >
            {props.activity.resource?.name ? (
              <WorkingStepResourceSelector
                workingStep={props.activity}
                bomItemPointersAndActivities={
                  props.bomItemPointersAndActivities
                }
                bomItemActivityId={
                  props.bomItemPointersAndActivities[0]?.activityId ??
                  props.activity.id
                }
                disableLabel
                disableUnderline
                disableMatchDescription
                disableSelectMaterialError
              />
            ) : (
              <Typography variant="caption" color="inherit">
                {t('project:no-resources-available')}
              </Typography>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
